/**
 * Format a number as currency with commas.
 * Omits decimals for whole numbers, shows 2 decimals when cents exist.
 * e.g. 1000 -> "1,000", 1234.5 -> "1,234.50"
 */
export function fmtCurrency(val) {
  const n = Number(val) || 0;
  return n % 1 === 0
    ? n.toLocaleString('en-US')
    : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/**
 * Format with $ prefix: "$1,000" or "$1,234.50"
 */
export function formatCurrency(val) {
  return `$${fmtCurrency(val)}`;
}
